import en from './en';
import { panelDwiOverrides } from './partials/panelDwiOverrides';
import { panelDepositBonusByLang } from './partials/panelDepositBonusI18n';
import { panelVoucherStatusByLang } from './partials/panelVoucherStatusI18n';
import { panelWithdrawBep20ByLang } from './partials/panelWithdrawBep20I18n';
import { panelDepositVoucherOverrides } from './partials/panelDepositVoucherOverrides';
import { panelInvestmentsOverrides } from './partials/panelInvestmentsI18n';
import { panelStopLossSlotsAssignOverrides } from './partials/panelStopLossSlotsAssignI18n';
import { panelStopLossFlowByLang } from './partials/panelStopLossFlowI18n';
import { panelUserSignupSocialForgotByLang } from './partials/panelUserSignupSocialForgotI18n';
import { panelAgentDashboardByLang } from './partials/panelAgentDashboardI18n';
import { panelAgentReferralsByLang } from './partials/panelAgentReferralsI18n';
import { panelAgentCommissionsByLang } from './partials/panelAgentCommissionsI18n';
import { panelAgentWithdrawByLang } from './partials/panelAgentWithdrawI18n';
import { panelAgentWithdrawUnlockStringsByLang } from './partials/panelAgentWithdrawUnlockStringsI18n';
import { panelAgentTransactionsByLang } from './partials/panelAgentTransactionsI18n';
import { panelAgentLogsByLang } from './partials/panelAgentLogsI18n';
import { panelAgentSettingsByLang } from './partials/panelAgentSettingsI18n';
import { panelAgentNotificationsByLang } from './partials/panelAgentNotificationsI18n';
import { panelAgentTeamByLang } from './partials/panelAgentTeamI18n';
import { panelAgentSignupByLang } from './partials/panelAgentSignupI18n';
import { panelAgentLayoutByLang } from './partials/panelAgentLayoutI18n';
import { panelAgentAuthByLang } from './partials/panelAgentAuthI18n';
import { panelSettingsTransactionsByLang, panelUserExtraByLang } from './partials/panelSettingsTransactions';
import { panelUserPlatformTodayByLang } from './partials/panelUserPlatformTodayI18n';
import { panelStopLossHowLayoutByLang } from './partials/panelStopLossHowLayoutI18n';
import { panelSupportTicketsByLang } from './partials/panelSupportTicketsI18n';
import { panelReferralRankingByLang } from './partials/panelReferralRankingI18n';

function m(p) {
  return { ...en, ...p };
}

export default m({
  'common.theme': 'Тема',
  'common.themeLight': 'Светлая',
  'common.themeDark': 'Тёмная',
  'common.themeActive': 'Сейчас активна',
  'common.themeSwitchToDark': 'Переключить на тёмную',
  'common.themeSwitchToLight': 'Переключить на светлую',
  'common.settings': 'Настройки',
  'common.loading': 'Загрузка…',
  'settings.language': 'Язык',
  'settings.savePreferences': 'Сохранить настройки',
  'settings.savingPreferences': 'Сохранение…',
  'auth.gate.userTitle': 'Проверка сессии',
  'auth.gate.userDescription': 'Подтверждение входа. Подождите.',
  'auth.gate.agentTitle': 'Проверка сессии',
  'auth.gate.agentDescription': 'Подтверждение входа агента. Подождите.',
  'user.layout.sidebarTitle': 'MineMe Пользователь',
  'user.layout.logout': 'Выход',
  'user.layout.nav.dashboard': 'Панель',
  'user.layout.nav.deposit': 'Депозит',
  'user.layout.nav.withdraw': 'Вывод',
  'user.layout.nav.investments': 'Инвестиции',
  'user.layout.nav.referral': 'Рефералы',
  'user.layout.nav.notifications': 'Уведомления',
  'user.layout.nav.stopLoss': 'Стоп-лосс',
  'user.layout.nav.transactions': 'Транзакции',
  'user.layout.nav.settings': 'Настройки',
  'user.layout.balance.available': 'Доступный баланс',
  'user.layout.balance.frozen': 'Замороженный баланс',
  'user.layout.balance.interest': 'Баланс процентов',
  'user.layout.balance.bonus': 'Бонусный баланс',
  'user.dashboard.balance.available': 'Доступный баланс',
  'user.dashboard.balance.frozen': 'Замороженный баланс',
  'user.dashboard.balance.interest': 'Начисленные проценты',
  'user.dashboard.balance.bonus': 'Бонусный баланс',

  'common.time.days': 'Дни',
  'common.time.hours': 'Часы',
  'common.time.minutes': 'Минуты',
  'common.time.seconds': 'Секунды',

  'user.dashboard.title': 'Панель',
  'user.dashboard.loadingInvestments': 'Загрузка статуса инвестиций…',
  'user.dashboard.stats.totalInvested': 'Всего инвестировано',
  'user.dashboard.stats.netPnl': 'Чистая прибыль / убыток',
  'user.dashboard.stats.activePlans': 'Активные планы',
  'user.dashboard.noInvestment.title': 'Нет активных инвестиций',
  'user.dashboard.noInvestment.subtitle':
    'Начните инвестировать сегодня и приумножайте капитал с привлекательной доходностью',
  'user.dashboard.noInvestment.cta': 'Смотреть инвестиционные планы',
  'user.dashboard.recentTx.title': 'Последние транзакции',
  'user.dashboard.recentTx.viewAll': 'Показать все',
  'user.dashboard.recentTx.col.date': 'Дата',
  'user.dashboard.recentTx.col.type': 'Тип',
  'user.dashboard.recentTx.col.description': 'Описание',
  'user.dashboard.recentTx.col.amount': 'Сумма',
  'user.dashboard.recentTx.col.status': 'Статус',
  'user.dashboard.recentTx.loading': 'Загрузка последних транзакций…',
  'user.dashboard.recentTx.empty': 'Нет последних транзакций.',
  'user.dashboard.tx.Deposit': 'Депозит',
  'user.dashboard.tx.Investment': 'Инвестиция',
  'user.dashboard.tx.Referral': 'Реферал',
  'user.dashboard.tx.Bonus': 'Бонус',
  'user.dashboard.tx.Withdrawal': 'Вывод',
  'user.dashboard.tx.E-Voucher': 'Электронный ваучер',
  'user.dashboard.tx.Stop-Loss': 'Стоп-лосс',
  'user.dashboard.st.Completed': 'Завершено',
  'user.dashboard.st.Active': 'Активно',
  'user.dashboard.st.Pending': 'В ожидании',
  'user.dashboard.st.Failed': 'Ошибка',
  'user.dashboard.invest.planFallback': 'План',
  'user.dashboard.invest.activeBadge': 'Активно',
  'user.dashboard.invest.detail.amountInvested': 'Инвестированная сумма',
  'user.dashboard.invest.detail.currentValue': 'Текущая стоимость',
  'user.dashboard.invest.detail.pl': 'П/У',
  'user.dashboard.invest.detail.interestRate': 'Процентная ставка',
  'user.dashboard.invest.detail.perMonth': '{{pct}}% в месяц',
  'user.dashboard.invest.detail.duration': 'Срок',
  'user.dashboard.invest.detail.months': '{{n}} мес.',
  'user.dashboard.invest.detail.startDate': 'Дата начала',
  'user.dashboard.invest.detail.nextWithdrawal': 'Следующий вывод',
  'user.dashboard.invest.countdownTitle': 'Следующий вывод через',
  'user.dashboard.invest.progress': 'Прогресс',
  'user.dashboard.invest.progressPct': '{{pct}}% завершено',
  'user.dashboard.invest.earlyWithdraw': 'Досрочный вывод',
  'user.dashboard.invest.planChip': '{{name}} № {{num}}',
  'user.dashboard.invest.modal.title': 'Предупреждение: досрочный вывод',
  'user.dashboard.invest.modal.investmentAmount': 'Сумма инвестиции:',
  'user.dashboard.invest.modal.platformFee': 'Комиссия платформы ({{pct}}%):',
  'user.dashboard.invest.modal.interestForfeited': 'Упущенные проценты:',
  'user.dashboard.invest.modal.youWillReceive': 'Вы получите:',
  'user.dashboard.invest.modal.confirmHint': 'Введите CONFIRM, чтобы продолжить',
  'user.dashboard.invest.modal.placeholderConfirm': 'CONFIRM',
  'user.dashboard.invest.modal.confirmWithdraw': 'Подтвердить вывод',
  'user.dashboard.invest.modal.cancelling': 'Отмена…',
  'user.dashboard.invest.toast.cancelled': 'Инвестиция отменена',
  'user.dashboard.invest.toast.cancelFailed': 'Не удалось отменить',

  'notifications.bell.triggerAria': 'Уведомления',
  'notifications.bell.title': 'Уведомления',
  'notifications.bell.loading': 'Загрузка…',
  'notifications.bell.loadErrorSubtitle': 'Не удалось загрузить уведомления',
  'notifications.bell.unreadOne': '1 непрочитанное обновление',
  'notifications.bell.unreadMany': '{{count}} непрочитанных обновлений',
  'notifications.bell.allCaughtUp': 'Новых уведомлений нет',
  'notifications.bell.markAllRead': 'Отметить все как прочитанные',
  'notifications.bell.empty': 'Пока нет уведомлений',
  'notifications.bell.emptyError': 'Не удалось загрузить уведомления',
  'notifications.bell.viewAll': 'Показать все',
  'notifications.bell.markReadAria': 'Отметить как прочитанное',
  'notifications.bell.time.justNow': 'только что',
  'notifications.bell.time.secondsAgo': '{{n}} с назад',
  'notifications.bell.time.minutesAgo': '{{n}} мин назад',
  'notifications.bell.time.hoursAgo': '{{n}} ч назад',
  'notifications.bell.time.daysAgo': '{{n}} д назад',

  'agent.layout.logout': 'Выход',
  'agent.layout.nav.dashboard': 'Панель',
  'auth.user.login.title': 'Вход пользователя',
  'auth.user.login.signIn': 'Войти',
  'auth.agent.login.title': 'Вход агента',
  'auth.agent.login.signIn': 'Войти',

  ...panelSettingsTransactionsByLang.ru,
  ...panelReferralRankingByLang.ru,
  ...panelUserExtraByLang.ru,
  ...panelDwiOverrides.ru,
  ...panelDepositBonusByLang.ru,
  ...panelVoucherStatusByLang.ru,
  ...panelWithdrawBep20ByLang.ru,
  ...panelDepositVoucherOverrides.ru,
  ...panelInvestmentsOverrides.ru,
  'user.investments.card.dailyProfit': 'Дневная прибыль',
  'user.investments.card.earningDays': 'Рабочие дни',
  'user.investments.card.earningDaysValue': '{{count}} раб. дн.',
  'user.investments.card.expectedProfit': 'Ожидаемая прибыль',
  'user.investments.card.investLimit': 'Лимит инвестиций',
  'user.investments.card.investLimitLine': '{{count}}× за {{days}} дн.',
  'user.investments.card.investLimitReached':
    'Вы достигли лимита инвестиций по этому плану в текущем периоде.',
  'user.investments.card.limitReached': 'Лимит достигнут',
  ...panelStopLossSlotsAssignOverrides.ru,
  ...panelStopLossFlowByLang.ru,
  ...panelUserSignupSocialForgotByLang.ru,
  ...panelAgentDashboardByLang.ru,
  ...panelAgentReferralsByLang.ru,
  ...panelAgentCommissionsByLang.ru,
  ...panelAgentWithdrawByLang.ru,
  ...panelAgentWithdrawUnlockStringsByLang.ru,
  'agent.withdraw.unlock.loadingTitle': 'Проверка статуса вывода…',
  'agent.withdraw.unlock.loadingSubtitle':
    'Загрузка прогресса рефералов и требований для разблокировки',
  'agent.withdraw.form.loadingTitle': 'Загрузка данных о выводе…',
  'agent.withdraw.form.loadingHint': 'Подождите, загружаем баланс и статус разблокировки',
  'agent.withdraw.unlock.requirementMet': 'Требование выполнено',
  'agent.withdraw.unlock.minDepositHint':
    'Учитываются только приглашённые пользователи (не суб-агенты). У каждого должно быть не менее ${{amount}} завершённых депозитов.',
  ...panelAgentTransactionsByLang.ru,
  ...panelAgentLogsByLang.ru,
  ...panelAgentSettingsByLang.ru,
  ...panelAgentNotificationsByLang.ru,
  ...panelAgentTeamByLang.ru,
  ...panelAgentSignupByLang.ru,
  ...panelAgentLayoutByLang.ru,
  ...panelAgentAuthByLang.ru,
  ...panelUserPlatformTodayByLang.ru,
  ...panelStopLossHowLayoutByLang.ru,
  ...panelSupportTicketsByLang.ru,
});
